var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('validation-observer', {
    ref: "form"
  }, [_c('b-card', [!_vm.isInvoiceAvailable ? _c('b-form-group', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pilih No.Invoice")]), _c('v-select', {
    attrs: {
      "reduce": function reduce(option) {
        return option.value;
      },
      "options": _vm.invoiceList,
      "label": "text"
    },
    model: {
      value: _vm.selectedInvoice,
      callback: function callback($$v) {
        _vm.selectedInvoice = $$v;
      },
      expression: "selectedInvoice"
    }
  })], 1) : _c('p', {
    staticClass: "mb-0"
  }, [_c('strong', [_vm._v("ID " + _vm._s(_vm.pb.id) + " No. Invoice: " + _vm._s(_vm.pb.id))])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-card', [_c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "bordered": "",
      "fields": _vm.fields,
      "items": _vm.barangs
    },
    scopedSlots: _vm._u([{
      key: "cell(action)",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('b-form-radio', {
          attrs: {
            "value": item,
            "name": "barang"
          },
          model: {
            value: _vm.selectedBarang,
            callback: function callback($$v) {
              _vm.selectedBarang = $$v;
            },
            expression: "selectedBarang"
          }
        })];
      }
    }, {
      key: "cell(barang)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.barang ? item.nama : '-') + " ")];
      }
    }, {
      key: "cell(satuan)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.barang && item.satuan ? item.satuan.satuan : '-') + " ")];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-card', [_c('form', [!_vm.isInvoiceAvailable ? _c('b-form-group', {
    attrs: {
      "hidden": ""
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "penerimaan",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Pilih Penerimaan")]), _c('v-select', {
          attrs: {
            "options": _vm.invoiceList,
            "required": !_vm.form.penerimaan_id,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "text"
          },
          model: {
            value: _vm.form.penerimaan_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "penerimaan_id", $$v);
            },
            expression: "form.penerimaan_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 1583463876)
  })], 1) : _vm._e(), _c('b-form-group', [_c('validation-provider', {
    attrs: {
      "name": "gudang",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var errors = _ref5.errors;
        return [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Pilih Gudang")]), _c('v-select', {
          attrs: {
            "options": _vm.gudangs,
            "required": !_vm.form.gudang_id,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "text"
          },
          model: {
            value: _vm.form.gudang_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "gudang_id", $$v);
            },
            expression: "form.gudang_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', [_c('validation-provider', {
    attrs: {
      "name": "blok",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var errors = _ref6.errors;
        return [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Pilih Blok")]), _c('v-select', {
          attrs: {
            "options": _vm.bloks,
            "required": !_vm.form.blok_id,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "text"
          },
          model: {
            value: _vm.form.blok_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "blok_id", $$v);
            },
            expression: "form.blok_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pilih Pallet")]), _c('v-select', {
    attrs: {
      "options": _vm.palets,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text"
    },
    model: {
      value: _vm.form.palet_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "palet_id", $$v);
      },
      expression: "form.palet_id"
    }
  })], 1), _c('b-form-group', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pilih Rak (optional)")]), _c('v-select', {
    staticClass: "mb-2",
    attrs: {
      "options": _vm.raks,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text"
    },
    model: {
      value: _vm.form.rak_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "rak_id", $$v);
      },
      expression: "form.rak_id"
    }
  })], 1), _c('b-form-group', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pilih Laci (optional)")]), _c('v-select', {
    staticClass: "mb-2",
    attrs: {
      "options": _vm.lacis,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text"
    },
    model: {
      value: _vm.form.laci_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "laci_id", $$v);
      },
      expression: "form.laci_id"
    }
  })], 1), _c('b-form-group', [_c('validation-provider', {
    attrs: {
      "name": "jumlah",
      "rules": "required|positive"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var errors = _ref7.errors;
        return [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Jumlah")]), _c('b-form-input', {
          staticClass: "mb-2",
          attrs: {
            "type": "number"
          },
          model: {
            value: _vm.form.jumlah,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "jumlah", $$v);
            },
            expression: "form.jumlah"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.addBarang($event);
      }
    }
  }, [_vm._v("Tambah")])], 1)], 1)])], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', [_c('b-table', {
    attrs: {
      "fields": _vm.fieldsAddedItems,
      "bordered": "",
      "striped": "",
      "responsive": "",
      "items": _vm.addedItems
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(row.index + 1) + " ")];
      }
    }, {
      key: "cell(lokasi)",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c('strong', [_vm._v(" " + _vm._s(item.lokasi) + " ")])];
      }
    }, {
      key: "cell(action)",
      fn: function fn(row) {
        return [_c('b-link', {
          staticClass: "text-danger",
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.addedItems.splice(row.index, 1);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "size": "24",
            "icon": "XCircleIcon"
          }
        })], 1)];
      }
    }])
  }), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_vm._v(" Simpan ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }